/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const EvalDatasetFormat = {
  Jsonl: "jsonl",
  Csv: "csv",
} as const;
export type EvalDatasetFormat = ClosedEnum<typeof EvalDatasetFormat>;

/** @internal */
export const EvalDatasetFormat$inboundSchema: z.ZodNativeEnum<
  typeof EvalDatasetFormat
> = z.nativeEnum(EvalDatasetFormat);
/** @internal */
export const EvalDatasetFormat$outboundSchema: z.ZodNativeEnum<
  typeof EvalDatasetFormat
> = EvalDatasetFormat$inboundSchema;
